import { Component } from '@angular/core';

@Component({
  selector: 'pm-form-panel',
  //templateUrl: './app/controls/components/panel/form-panel/form-panel.html',
  templateUrl: './form-panel.html'
})
export class FormPanelComponent { }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/panels/form-panel/form-panel-component.ts